export const dbData = {
    "products": {
        "blue": {
            "id": 1,
            "price": "699",
            "oldPrice": "1049",
            "image": "/image/vitaplex.webp",
            "packImage": "/image/prd1.webp",
            "hoverImage": "/image/prd4.webp",
            "en": {
                "name": "Protein+ Shampoo Vitaplex Volumizing",
                "brand": "VITAPLEX",
                "size_ml": 1000,
                "type": "Protein+ Shampoo Volumizing",
                "description": "Advanced protein therapy for increased density and structural strength.",
                "ingredients": [
                    "Protein",
                    "Collagen"
                ],
                "free_from": [
                    "Sulfate",
                    "Paraben",
                    "Glyoxylic Acid"
                ],
                "benefits": [
                    "Protein Density",
                    "Fiber Strength",
                    "Bio-Active Clean"
                ],
                "hair_type": "All types",
                "usage": "Professional",
                "buyLabel": "Buy now"
            },
            "fr": {
                "name": "Protein+ Shampooing Vitaplex Volumisant",
                "brand": "VITAPLEX",
                "size_ml": 1000,
                "type": "Protein+ Shampooing Volumisant",
                "description": "Thérapie protéinée avancée pour une densité accrue et une force structurelle.",
                "ingredients": [
                    "Protéine",
                    "Collagène"
                ],
                "free_from": [
                    "Sans Sulfate",
                    "Sans Parabène",
                    "Sans Acide Glyoxylique"
                ],
                "benefits": [
                    "Densité Protéinée",
                    "Force de la Fibre",
                    "Soin Bio-Actif"
                ],
                "hair_type": "Tous types",
                "usage": "Professionnel",
                "buyLabel": "Acheter"
            },
            "ar": {
                "name": "بروتين+ شامبو فيتابليكس للتكثيف",
                "brand": "فيتابليكس",
                "size_ml": 1000,
                "type": "بروتين+ شامبو مكثف",
                "description": "علاج بروتيني متطور لزيادة الكثافة والقوة الهيكلية للشعر.",
                "ingredients": [
                    "البروتين",
                    "الكولاجين"
                ],
                "free_from": [
                    "خالي من السلفات",
                    "خالي من البارابين",
                    "خالي من حمض الجليوكسيليك"
                ],
                "benefits": [
                    "كثافة البروتين",
                    "قوة الألياف",
                    "تنظيف حيوي"
                ],
                "hair_type": "جميع الأنواع",
                "usage": "احترافي",
                "buyLabel": "اشتري الآن"
            }
        },
        "pink": {
            "id": 2,
            "price": "110",
            "oldPrice": "160",
            "image": "/image/vitaplex.webp",
            "en": {
                "name": "Protein+ Shampoo Vitaplex Moisturizing",
                "brand": "VITAPLEX",
                "size_ml": 1000,
                "type": "Protein+ Shampoo Moisturizing",
                "description": "Deep protein infusion for weightless hydration and silky resilience.",
                "ingredients": [
                    "Argan Oil",
                    "Vitamin E",
                    "Silk Protein"
                ],
                "free_from": [
                    "Sulfate",
                    "Paraben",
                    "Alcohol"
                ],
                "benefits": [
                    "Silk Infusion",
                    "Elasticity",
                    "Luminous Shine"
                ],
                "hair_type": "Dry/Damaged",
                "usage": "Twice a week",
                "buyLabel": "Buy now"
            },
            "fr": {
                "name": "Protein+ Shampooing Vitaplex Hydratant",
                "brand": "VITAPLEX",
                "size_ml": 1000,
                "type": "Protein+ Shampooing Hydratant",
                "description": "Infusion de protéines profonde pour une hydratation aérienne et une résilience soyeuse.",
                "ingredients": [
                    "Huile d'Argan",
                    "Vitamine E",
                    "Protéine de Soie"
                ],
                "free_from": [
                    "Sans Sulfate",
                    "Sans Parabène",
                    "Sans Alcool"
                ],
                "benefits": [
                    "Infusion de Soie",
                    "Élasticité",
                    "Brillance Lumineuse"
                ],
                "hair_type": "Secs/Abîmés",
                "usage": "Deux fois par semaine",
                "buyLabel": "Acheter"
            },
            "ar": {
                "name": "بروتين+ شامبو فيتابليكس المرطب",
                "brand": "فيتابليكس",
                "size_ml": 1000,
                "type": "بروتين+ شامبو مرطب",
                "description": "حقن بروتيني عميق لترطيب خفيف ومرونة حريرية.",
                "ingredients": [
                    "زيت الأرجان",
                    "فيتامين E",
                    "بروتين الحرير"
                ],
                "free_from": [
                    "خالي من السلفات",
                    "خالي من البارابين",
                    "خالي من الكحول"
                ],
                "benefits": [
                    "بروتين الحرير",
                    "مرونة",
                    "لمعان فائق"
                ],
                "hair_type": "جاف/تالف",
                "usage": "مرتين في الأسبوع",
                "buyLabel": "اشتري الآن"
            }
        },
        "red": {
            "id": 3,
            "price": "847",
            "oldPrice": "1270",
            "image": "/image/betslove.webp",
            "packImage": "/image/prd2.webp",
            "hoverImage": "/image/prd3.webp",
            "en": {
                "name": "Protein+ Shampoo Best Love Repairing",
                "brand": "BEST LOVE",
                "size_ml": 1000,
                "type": "Protein+ Shampoo Repairing",
                "description": "Intensive protein reconstruction for severely damaged or chemically treated hair.",
                "ingredients": [
                    "Biotin",
                    "Caffeine",
                    "Amino Acids"
                ],
                "free_from": [
                    "Sulfate",
                    "Paraben",
                    "Dyes"
                ],
                "benefits": [
                    "Fiber Repair",
                    "Structural Growth",
                    "Core Strength"
                ],
                "hair_type": "Color-treated",
                "usage": "Professional",
                "buyLabel": "Buy now"
            },
            "fr": {
                "name": "Protein+ Shampooing Best Love Réparateur",
                "brand": "BEST LOVE",
                "size_ml": 1000,
                "type": "Protein+ Shampooing Réparateur",
                "description": "Reconstruction protéinée intensive pour les cheveux sévèrement abîmés ou traités.",
                "ingredients": [
                    "Biotine",
                    "Caféine",
                    "Acides Aminés"
                ],
                "free_from": [
                    "Sans Sulfate",
                    "Sans Parabène",
                    "Sans Colorant"
                ],
                "benefits": [
                    "Réparation Fibreuse",
                    "Croissance Structurelle",
                    "Force du Noyau"
                ],
                "hair_type": "Colorés",
                "usage": "Professionnel",
                "buyLabel": "Acheter"
            },
            "ar": {
                "name": "بروتين+ شامبو بيست لوف المرمم",
                "brand": "بيست لوف",
                "size_ml": 1000,
                "type": "بروتين+ شامبو مرمم",
                "description": "إعادة بناء بروتينية مكثفة للشعر التالف بشدة أو المعالج كيميائياً.",
                "ingredients": [
                    "البيوتين",
                    "الكافيين",
                    "الأحماض الأمينية"
                ],
                "free_from": [
                    "خالي من السلفات",
                    "خالي من البارابين",
                    "خالي من الأصباغ"
                ],
                "benefits": [
                    "إصلاح الألياف",
                    "نمو هيكلي",
                    "قوة الجوهر"
                ],
                "hair_type": "مصبوغ",
                "usage": "احترافي",
                "buyLabel": "اشتري الآن"
            }
        },
        "white": {
            "id": 4,
            "price": "95",
            "oldPrice": "140",
            "image": "/image/prd2.webp",
            "en": {
                "name": "Protein+ Shampoo Vitaplex Daily Clean",
                "brand": "VITAPLEX",
                "size_ml": 1000,
                "type": "Protein+ Shampoo Daily",
                "description": "Protein-fortified formula for daily protection and lightweight balance.",
                "ingredients": [
                    "Aloe Vera",
                    "Mint",
                    "Vitamin C"
                ],
                "free_from": [
                    "Sulfate",
                    "Paraben",
                    "Silicones"
                ],
                "benefits": [
                    "Daily Defense",
                    "Scalp Balance",
                    "Essential Protein"
                ],
                "hair_type": "All types",
                "usage": "Daily",
                "buyLabel": "Buy now"
            },
            "fr": {
                "name": "Protein+ Shampooing Vitaplex Nettoyage Quotidien",
                "brand": "VITAPLEX",
                "size_ml": 1000,
                "type": "Protein+ Shampooing Quotidien",
                "description": "Formule fortifiée en protéines pour une protection quotidienne et un équilibre léger.",
                "ingredients": [
                    "Aloe Vera",
                    "Menthe",
                    "Vitamine C"
                ],
                "free_from": [
                    "Sans Sulfate",
                    "Sans Parabène",
                    "Sans Silicone"
                ],
                "benefits": [
                    "Défense Quotidienne",
                    "Équilibre du Cuir Chevelu",
                    "Protéine Essentielle"
                ],
                "hair_type": "Tous types",
                "usage": "Quotidien",
                "buyLabel": "Acheter"
            },
            "ar": {
                "name": "بروتين+ شامبو فيتابليكس للتنظيف اليومي",
                "brand": "فيتابليكس",
                "size_ml": 1000,
                "type": "بروتين+ شامبو يومي",
                "description": "تركيبة مدعمة بالبروتين للحماية اليومية والتوازن الخفيف.",
                "ingredients": [
                    "الصبار",
                    "النعناع",
                    "فيتامين C"
                ],
                "free_from": [
                    "خالي من السلفات",
                    "خالي من البارابين",
                    "خالي من السيليكون"
                ],
                "benefits": [
                    "حماية يومية",
                    "توازن الفروة",
                    "بروتين أساسي"
                ],
                "hair_type": "جميع الأنواع",
                "usage": "يومي",
                "buyLabel": "اشتري الآن"
            }
        }
    },
    "variants_info": [
        {
            "id": 1,
            "name": "Blue",
            "color": "#0047ab",
            "productKey": "blue"
        },
        {
            "id": 2,
            "name": "Dark Pink",
            "color": "#e91e63",
            "productKey": "pink"
        },
        {
            "id": 3,
            "name": "Red",
            "color": "#f44336",
            "productKey": "red"
        },
        {
            "id": 4,
            "name": "White",
            "color": "#ffffff",
            "productKey": "white"
        }
    ]
};
